import "./navigation";
import "SLICK/slick.js";
import "MFP/jquery.magnific-popup.js";
import "./tabbit";
import "./togglize";
import "./two-col-text";


(function ($) {
  $(document).ready(function () {
    // console.log('starter theme...');

    $(".engrain-toggle").on("click", function (e) {
      console.log("click fdsakkfjh");
      $(".engrain-map").css({
        display: "block"
      });
    });
		
		$('.tabbed-gallery').tabbit({
			tabIdCreation: 'existing',
			'panelIdCreation': 'existing'
		});

    let twoCols = $(".two-col-content").twoColumnize();

    $(".video-control-button").on("click", function (e) {
      // console.log('click',e);
      let $this = $(this);
      let label = $this.attr("aria-label");
      if (label === "play") {
        $this.attr("aria-label", "pause");
        $this.parent().siblings("video").trigger("play");
      } else {
        $this.attr("aria-label", "play");
        $this.parent().siblings("video").trigger("pause");
      }
      // console.log("video: ", $this.parent().siblings("video"));
    });

    function reduceAllMotion() {
      console.log("reducing motion...");
      $("video").prop("autoplay", false).siblings(".video-control-button-container").find(".video-control-button").attr("aria-label", "play");
    }

    $(".multi-image-lightbox").each(function (e) {
      $(this)
        .find("a.image-link")
        .magnificPopup({
          // delegate: "a",
          type: "image",
          image: {
            markup:
              '<div class="mfp-figure">' +
              '<div class="mfp-close"></div>' +
              '<div class="mfp-img"></div>' +
              '<div class="mfp-bottom-bar">' +
              '<div class="mfp-title"></div>' +
              '<div class="mfp-counter"></div>' +
              "</div>" + // end .mfp-bottom-bar
              "</div>", // Popup HTML markup. `.mfp-img` di
            titleSrc: function (item) {
              // console.log(item);
              return item.img.attr("alt");
            },
            verticalFit: true // Fits image in area vertically
          },
          gallery: {
            enabled: true,
            navigateByImgClick: true,

            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

            tPrev: "Previous (Left arrow key)", // title for left button
            tNext: "Next (Right arrow key)", // title for right button
            tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
          }
        });
    });

    // Magnific popup for standard image
    $(".lyst-lightbox-standard-image").magnificPopup({
      type: "image",
      image: {
        markup:
          '<div class="mfp-figure lightbox-standard-image">' +
          '<div class="mfp-close"></div>' +
          '<div class="mfp-img"></div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '<div class="mfp-counter"></div>' +
          "</div>" + // end .mfp-bottom-bar
          "</div>", // Popup HTML markup. `.mfp-img` di

        verticalFit: true // Fits image in area vertically
      }
    });

    // Magnific popup for floor plans
    $(".lyst-lightbox-fp-image").magnificPopup({
      type: "image",
      image: {
        markup:
          '<div class="mfp-figure floor-plan-image">' +
          '<div class="mfp-close"></div>' +
          '<div class="mfp-img"></div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '<div class="mfp-counter"></div>' +
          "</div>" + // end .mfp-bottom-bar
          "</div>", // Popup HTML markup. `.mfp-img` di
        titleSrc: function (item) {
          return "<small>Room dimensions and square footage may vary from those shown on this plan. Floorplans are for illustrative purposes only. Please contact your leasing representative for detailed information on your selected plan.</small>";
        },
        verticalFit: true // Fits image in area vertically
      }
    });

    // Magnific popup not for photo gallery image
    $(".lyst-lightbox-image").magnificPopup({
      type: "image",
      image: {
        markup:
          '<div class="mfp-figure">' +
          '<div class="mfp-close"></div>' +
          '<div class="mfp-img"></div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '<div class="mfp-counter"></div>' +
          "</div>" + // end .mfp-bottom-bar
          "</div>", // Popup HTML markup. `.mfp-img` di

        verticalFit: true // Fits image in area vertically
      }
    });

    $(".open-popup-link").magnificPopup({
      type: "inline",

      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    $(".fp-gallery-button").on("click", function (e) {
      e.preventDefault();
      let targetGallerySelector = $(this).data("mfp-src");
      let $items = [];
      $(targetGallerySelector)
        .children(".fp-photo")
        .each(function () {
          $items.push({ src: $(this).children("img").attr("src") });
        });
      $.magnificPopup.open({
        items: $items,
        type: "image",
        gallery: {
          enabled: true
        }
      });
    });

    $(".carousel").slick({
      lazyLoad: "ondemand",
      arrows: true,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 6000,
      rows: 0,
      infinite: true,
      adaptiveHeight: false,
      // prevArrow: "<button class='slick-prev long-arrow-left slick-arrow' type='button' style=''><span aria-hidden='true'></span><span class='slick-sr-only'>Prev</span></button>",
      // nextArrow: "<button class='slick-next long-arrow-right slick-arrow' type='button' style=''><span aria-hidden='true'></span><span class='slick-sr-only'>Next</span></button>",
      // prevArrow: "<button class='slick-prev slick-arrow' type='button' style=''><span class='custom-arrow-left'>&#10229;</span><span aria-hidden='true'></span><span class='slick-sr-only'>Prev</span></button>",
      // nextArrow: "<button class='slick-next slick-arrow' type='button' style=''><span class='custom-arrow-right'>&#10230;</span><span aria-hidden='true'></span><span class='slick-sr-only'>Next</span></button>",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            lazyLoad: "ondemand",
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        }
      ]
    });

    $(".simple-slider").slick({
      lazyLoad: "ondemand",
      arrows: true,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      // adaptiveHeight: true,
      centerMode: false,
      // centerPadding: "100px",
      // autoplay: true,
      // autoplaySpeed: 6000,
      rows: 0,
      infinite: true,
      // prevArrow: "<button class='slick-prev long-arrow-left slick-arrow' type='button' style=''><span aria-hidden='true'></span><span class='slick-sr-only'>Prev</span></button>",
      // nextArrow: "<button class='slick-next long-arrow-right slick-arrow' type='button' style=''><span aria-hidden='true'></span><span class='slick-sr-only'>Next</span></button>",
      nextArrow: `<button type="button" class="carousel-button carousel-next">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>
        <span class="sr-only">Next Image</span>
        </button>`,
      prevArrow: `<button type="button" class="carousel-button carousel-prev">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>
        <span class="sr-only">Previous Image</span>
        </button>`,
      responsive: [
        // {
        //   breakpoint: 1199,
        //   settings: {
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     lazyLoad: "ondemand",
        //     arrows: false,
        //     dots: true
        //   }
        // },
        {
          breakpoint: 980,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });

    // insert right arrow after contact form submit button
    // find the .gform_footer.top_label input and append the
    // span to it
    // $(".contact-form .gform_footer.top_label").append("<span class='arrow'></span>");
    // let floorPlansPageCheck = document.getElementById("floor-plans-widget");
    // if (floorPlansPageCheck) {
    const tabbed = document.querySelector(".tabbed");
    let tabs = false;
    let panels = false;
    let tablist = false;
    if (tabbed) {
      tablist = tabbed.querySelector("ul.tab-button-list");
      if (tablist) {
        tabs = tablist.querySelectorAll("a");
      }
      panels = tabbed.querySelectorAll(".floor-plan-category");
    }

    // The tab switching function
    const switchTab = (oldTab, newTab) => {
      newTab.focus();
      // Make the active tab focusable by the user (Tab key)
      newTab.removeAttribute("tabindex");
      // Set the selected state
      newTab.setAttribute("aria-selected", "true");
      // trigger slick refresh on the slider in the tab whenever a new tab is activated
      // you might need to have the refresh happen right after you change the styles on the section
      // function refreshSlick() {
      //   $(".tabbed li a[aria-selected=true]").parents('div.tabbed-buttons').siblings('div.floorplan-section-container').find('.simple-slider').slick('refresh');
      // }
      // refreshSlick();
      oldTab.removeAttribute("aria-selected");
      oldTab.setAttribute("tabindex", "-1");
      // Get the indices of the new and old tabs to find the correct
      // tab panels to show and hide
      let index = Array.prototype.indexOf.call(tabs, newTab);
      let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
      panels[oldIndex].hidden = true;
      panels[index].hidden = false;
    };

    if (tabbed && tablist && tabs && panels) {
      // Add the tablist role to the first <ul> in the .tabbed container
      tablist.setAttribute("role", "tablist");

      // Add semantics are remove user focusability for each tab
      Array.prototype.forEach.call(tabs, (tab, i) => {
        tab.setAttribute("role", "tab");
        tab.setAttribute("id", "tab" + (i + 1));
        tab.setAttribute("tabindex", "-1");
        tab.parentNode.setAttribute("role", "presentation");

        // Handle clicking of tabs for mouse users
        tab.addEventListener("click", e => {
          e.preventDefault();
          let currentTab = tablist.querySelector("[aria-selected]");
          if (e.currentTarget !== currentTab) {
            switchTab(currentTab, e.currentTarget);
          }
        });

        // Handle keydown events for keyboard users
        tab.addEventListener("keydown", e => {
          // Get the index of the current tab in the tabs node list
          let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
          // Work out which key the user is pressing and
          // Calculate the new tab's index where appropriate
          let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? "down" : null;
          if (dir !== null) {
            e.preventDefault();
            // If the down key is pressed, move focus to the open panel,
            // otherwise switch to the adjacent tab
            dir === "down" ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
          }
        });
      });

      // Add tab panel semantics and hide them all
      Array.prototype.forEach.call(panels, (panel, i) => {
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("tabindex", "-1");
        let id = panel.getAttribute("id");
        panel.setAttribute("aria-labelledby", tabs[i].id);
        panel.hidden = true;
      });

      // Initially activate the first tab and reveal the first tab panel
      tabs[0].removeAttribute("tabindex");
      tabs[0].setAttribute("aria-selected", "true");
      panels[0].hidden = false;
    } // end check for tabbed component on the page


    const fpWidgetTabbed = $("#floor-plans-widget").tabbit(
      {
        tabIdCreation: "href"
      }
    )
    // const $fpWidget = $("#floor-plans-widget");
    // // console.log($fpWidget);
    // if ($fpWidget.data('has-sitemap')) {
    //   let fpWidgetTabbed = $fpWidget.tabbit({
    //     tabIdCreation: "href"
    //   });
    // }

    // let $fpImageTab = $(".tabbed-fp-image").tabbit({
    //   tabIdCreation: "href"
    // });


    let $faqToggles = $(".toggle-item").togglize({
      action: "accordion",
      animate: true,
      animateSpeed: "0.5s",
      firstOpen: true,
      adaptiveHeight: false
    });

    // let $toggles = $(".togglize-me").togglize({
    //   action: "toggle",
    //   animate: window.noMotion ? false : true,
    //   animateSpeed: "1s",
    //   firstOpen: false
    // });

    // let $accordions = $(".accordionize-me").togglize({
    //   action: "accordion",
    //   animate: window.noMotion ? false : true,
    //   animateSpeed: "0.75s"
    // });

    $(".expandable a ").append("<span class='arrow'></span>");

    let amenitiesPageCheck = document.getElementById("expandit-grid");
    if (amenitiesPageCheck) {
      let expanditComponentList = document.querySelectorAll(".expandit-grid");

      expanditComponentList.forEach(expandit => {
        expandit.addEventListener("click", function (event) {
          if (event.currentTarget === event.target) {
            return;
          }
          let clickedExpanditItem = event.target.closest(".expandit-item");
          let expanditComponent = event.currentTarget;
          if (!clickedExpanditItem) {
            return;
          }
          if (clickedExpanditItem.classList.contains("expanded")) {
            clickedExpanditItem.classList.remove("expanded");
            event.target.ariaLabel = "expand image and reveal caption";
            expanditComponent.dataset.activeRow = -1;
            expanditComponent.dataset.activeCol = -1;
            return;
          }
          let clickedExpanditItemNumber = Array.from(expanditComponent.children).indexOf(clickedExpanditItem) + 1;
          if (clickedExpanditItemNumber < 3) {
            expanditComponent.dataset.activeRow = 1;
          } else {
            expanditComponent.dataset.activeRow = 2;
          }
          if (clickedExpanditItemNumber % 2 == 0) {
            expanditComponent.dataset.activeCol = 2;
          } else {
            expanditComponent.dataset.activeCol = 1;
          }
          console.log("item number: ", clickedExpanditItemNumber);
          clickedExpanditItem.classList.add("expanded");
          event.target.ariaLabel = "shrink image and hide caption";
          for (expanditItem of expanditComponent.children) {
            if (expanditItem !== clickedExpanditItem) {
              expanditItem.classList.remove("expanded");
            }
          }
        });
      });
    }
		
		let urlParams = new URLSearchParams(window.location.search);
		if (urlParams) {
			let activeTab = urlParams.get('tab');
			if (activeTab) {
				let $activeTab = $(`a[href="#${activeTab}"]`);
				console.log('activeTab: ', $activeTab);
				if ($activeTab) {
					console.log('clicking...');
					$activeTab.trigger('click');
				}
			}
		}

  }); // end document ready
})(jQuery);
